<!--节点管理-->
<template>
  <div>
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>节点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item">
          <el-button type="primary" size="small" @click="add" id="auto-0">新增节点</el-button>
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-1">
      <fe-table :tableData="tableData" :columns="columns" border :show-pagination="false">
        <!-- 关联地址 -->
        <template #linkAddress="{ scope }">
          <span>{{ scope.row.linkAddress ? scope.row.linkAddress : '未设置' }}</span>
        </template>
        <!-- 操作 -->
        <template #handle="{ scope }">
          <el-button type="text" class="font-size12" @click="showDetail(scope.row)">查看</el-button>
          <el-button type="text" class="font-size12" @click="del(scope.row)">删除</el-button>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:1
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';

export default {
  data() {
    return {
      columns: [
        { label: '节点名称', prop: 'signSiteName', 'min-width': 120 },
        { label: '关联地址', prop: 'linkAddress', 'min-width': 220 },
        { label: '收单规则', prop: 'ruleNamesListString', 'min-width': 100 },
        { label: '收单员', prop: 'receiveManNameListStr', 'min-width': 100 },
        { label: '操作', prop: 'handle', 'min-width': 120 }
      ],
      tableOptions: {},
      pagination: {
        pageNum: 1,
        pageSize: 500
      },
      axiosConfig: { url: api.querySignReceiveSiteList } // 列表接口
    };
  },
  mixins: [tableMixin],
  created() {
    this.handleSearch();
  },
  methods: {
    beforeResolve(data) {
      this.tableData = data || [];
      return false;
    },
    add() {
      // 跳转到新增节点路由
      this.$router.push({ path: '/companyRecipientAdd' });
    },
    showDetail(item) {
      this.$router.push({ path: '/companyRecipientAdd' , query: { siteCode: item.signSiteCode }});
      // // 跳转查看节点路由
      // this.$router.push({ name: 'companyRecipientDetail', query: { siteCode: item.signSiteCode} });
    },
    del(item) {
      this.$confirm('是否删除该节点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          /**
           * @Description  删除签收点
           * @param {string} siteCode  通用主键编码
           */
          await axios.post(api.compensateFreightDeleteSite, { siteCode: item.signSiteCode });
          this.$message.success('删除成功');
          this.handleSearch();
        })
        .catch(() => {});
    }
  }
};
</script>
